import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Country } from '../../../global/interfaces/country';
import parsePhoneNumber from 'libphonenumber-js';
import { HelperFunctions } from '../../../utils/helper.functions';

import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

export interface PhoneSelectInterface {
  inputHeight?: number; // default is 50 px
  inputWidth?: number; // default is 50 px
}

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PhoneComponent),
      multi: true,
    },
  ],
})
export class PhoneComponent implements OnChanges, ControlValueAccessor {
  clicked_times = 0;
  local_click: boolean;
  position = 'down';

  @Input() private options: PhoneSelectInterface;
  @Input() countries: Country[] = [];
  @Input() country: string;
  @Input() countryCode: string;
  @Input() countryIso: string;
  @Input() countryIso3: string;
  @Input() isDisabled: boolean;
  @Input() objectKey: string;
  @Input() objectValue: string;
  @Input() hasError: string;
  @Input() valuePlaceholder: string;
  @Input() inputHeight: number;
  @Input() inputWidth: number;
  @Input() showFlag: boolean;
  filter_field = true;
  countries_copy: Country[];

  flag: SafeResourceUrl = `/assets/images/favicon.png`;

  @ViewChild('selectDropdown')
  selectDropdown: ElementRef;
  @ViewChild('inputElement', { static: true })
  inputElement: ElementRef;

  selectDropdown_show: boolean;
  phoneNumber: string;
  wholePhoneNumber: string;

  // tslint:disable-next-line: no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  public onTouchCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  constructor(private helperFunctions: HelperFunctions, private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if ('countries' in changes) {
      this.cloneCountriesList();
    }
  }
  // get value from parent [(ngModel)] or formControl
  writeValue(value: string | any) {
    if (value) {
      this.wholePhoneNumber = value;
      if (this.wholePhoneNumber) {
        const phoneNumberParsed = parsePhoneNumber(this.wholePhoneNumber);
        this.phoneNumber = phoneNumberParsed?.nationalNumber as string;
        this.countryIso = phoneNumberParsed?.country ?? this.countryIso;
        this.countryCode = (phoneNumberParsed?.countryCallingCode as string) ?? this.countryCode;
        const country = this.helperFunctions.returnCountryIso(this.countries, this.countryIso)[0];
        this.countryIso3 = country.iso3;
        this.setFlag(country.flag);
      }
    }
  }
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchCallback = fn;
  }
  validate(AC: AbstractControl): ValidationErrors | null {
    return;
  }

  formatPhone(countryCode?: string) {
    if (this.phoneNumber && this.phoneNumber.length > 0 && this.phoneNumber.toString().charAt(0) === '0') {
      this.phoneNumber.slice(0, this.phoneNumber.length);
    }
    this.countryCode = countryCode ?? this.countryCode;
    this.wholePhoneNumber = '+' + this.countryCode + this.phoneNumber;
    if (this.phoneNumber && this.phoneNumber !== '') {
      this.change.emit(this.wholePhoneNumber);
      this.onChangeCallback(this.wholePhoneNumber);
    } else {
      this.change.emit('');
      this.onChangeCallback('');
    }
  }
  public dropdownItem_selected(value): boolean {
    return value === this.countryIso3;
  }
  public dropdownItem_select(value, e): void {
    e.stopImmediatePropagation();
    this.countryIso = value.iso;
    this.countryIso3 = value.iso3;
    this.setFlag(value.flag);
    this.country = value;
    this.formatPhone(value.phonecode);
    if (this.phoneNumber && this.phoneNumber !== '') {
      this.change.emit(this.wholePhoneNumber);
      this.onChangeCallback(this.wholePhoneNumber);
    }
    this.selectDropdown_close();
    return;
  }
  private selectDropdown_close(): void {
    this.selectDropdown_show = false;
    this.countries = this.countries_copy;
  }
  public selectDropdown_toggle(): void {
    if (!this.isDisabled) {
      this.selectDropdown_show = !this.selectDropdown_show;
      if (!this.selectDropdown_show) {
        this.clicked_times = 0;
      }
    }
  }

  findIsoCountry() {
    this.countries.forEach((country) => {
      if (country.iso3 === this.country) {
        this.countryIso = country.iso;
        this.setFlag(country.flag);
      }
    });
  }
  public valuesSelected_get_first(): string {
    if (this.countries.length > 0) {
      const found: Country =
        (this.countryIso3 && this.countries.find((item) => item[this.objectKey] === this.countryIso3)) || null;
      if (this.showFlag) {
        this.setFlag(found ? found.flag : this.countries[0]?.flag);
      }
      return found ? found[this.objectValue] : this.countries[0][this.objectValue];
    }
    return;
  }
  public havePhoneCodeValue() {
    return this.countryCode && this.countryCode !== '';
  }
  setFlag(flag) {
    this.flag = this.sanatizeFlag(flag);
  }
  sanatizeFlag(data: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + data);
  }
  dropdownItem_filter(event) {
    this.countries = this.countries_copy;

    this.countries = this.countries.filter(
      (dropdownItem) => dropdownItem.name && dropdownItem.name.toLowerCase().includes(event.target.value.toLowerCase()),
    );
  }
  cloneCountriesList() {
    this.countries_copy = this.countries;
  }
  @HostListener('click', ['$event'])
  onLocalClick(event: Event) {
    this.local_click = true;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: any) {
    const dropdown_inner_height = (this.selectDropdown && this.selectDropdown.nativeElement.offsetHeight) || 0;
    const input_bounds = (this.inputElement && this.inputElement.nativeElement.getBoundingClientRect()) || 0;
    this.clicked_times++;
    if (this.clicked_times <= 2) {
      if (window.innerHeight < input_bounds.y + dropdown_inner_height + input_bounds.height) {
        this.position = 'down';
      } else {
        this.position = 'up';
      }
    }
    if (!this.local_click && this.clicked_times >= 2) {
      this.selectDropdown_close();
      this.clicked_times = 0;
    }
    this.local_click = false;
  }
}
